import { render, staticRenderFns } from "./GoodsTable.vue?vue&type=template&id=94e4c770&scoped=true"
import script from "./GoodsTable.vue?vue&type=script&lang=js"
export * from "./GoodsTable.vue?vue&type=script&lang=js"
import style0 from "./GoodsTable.vue?vue&type=style&index=0&id=94e4c770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e4c770",
  null
  
)

export default component.exports